import { memo, useId } from 'react'

import styles from './DiamondAnimation.module.scss'

type Props = {
  diamondColor?: string
  optimized?: boolean
}

export const DiamondAnimation = memo(function DiamondAnimation({ optimized = false, diamondColor = "#7F7F7F" }: Props) {
  const paint2DiamondClipPathId = useId()
  const paint2DiamondId = useId()

  return (
    <g
      className={optimized ? styles.container : undefined}
      style={{ mixBlendMode: 'plus-lighter' }}
    >
      {Array.from({ length: 10 }).map((_, index) => (
        <g
          key={index}
          style={{ transformOrigin: 'center' }}
          transform={`rotate(${index * 36 + index * 5} 0 0) scale(${
            Math.random() * 0.5 + 0.5
          })`}
        >
          {!optimized && (
            <>
              <animateTransform
                attributeName="transform"
                type="scale"
                from="1"
                to="2"
                dur="6s"
                repeatCount="indefinite"
                values="1;1.3;1"
                keyTimes="0;0.5;1"
                additive="sum"
              />
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0"
                to="360"
                dur="30s"
                repeatCount="indefinite"
                additive="sum"
              />
            </>
          )}
          <g clipPath={`url(#${paint2DiamondClipPathId})`}>
            <g transform="matrix(0.00526975 0.019667 -0.0951336 0.0254909 100.97 91.8329)">
              <rect
                x="0"
                y="0"
                width="1028.38"
                height="1005.87"
                fill={`url(#${paint2DiamondId})`}
                opacity="1"
                shapeRendering="crispEdges"
              />
              <rect
                x="0"
                y="0"
                width="1028.38"
                height="1005.87"
                transform="scale(1 -1)"
                fill={`url(#${paint2DiamondId})`}
                opacity="1"
                shapeRendering="crispEdges"
              />
              <rect
                x="0"
                y="0"
                width="1028.38"
                height="1005.87"
                transform="scale(-1 1)"
                fill={`url(#${paint2DiamondId})`}
                opacity="1"
                shapeRendering="crispEdges"
              />
              <rect
                x="0"
                y="0"
                width="1028.38"
                height="1005.87"
                transform="scale(-1)"
                fill={`url(#${paint2DiamondId})`}
                opacity="1"
                shapeRendering="crispEdges"
              />
            </g>
          </g>
          <rect
            x="11.106"
            y="136.991"
            width="40.7216"
            height="196.979"
            transform="rotate(-105 11.106 136.991)"
          />
        </g>
      ))}
      <defs>
        <clipPath id={paint2DiamondClipPathId}>
          <rect
            x="11.106"
            y="136.991"
            width="40.7216"
            height="196.979"
            transform="rotate(-105 11.106 136.991)"
          />
        </clipPath>
        <linearGradient
          id={paint2DiamondId}
          x1="0"
          y1="0"
          x2="500"
          y2="500"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={diamondColor} />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
      </defs>
    </g>
  )
})
